module.exports = __webpack_public_path__ + "static/logo-small-a61614e91c2a0217d1c2ed9915acf712.svg";